define('GameDayCore/GDModel/enums/datasources/Datasources',{
    GUMBO: "gumbo",
    PLAYS: "play",
    PLAYERS: "players",
    GAME: "game",
    BOXSCORE: "boxscore",
    BENCH: "bench",
    LINESCORE: "linescore",
    LINEUP: "lineup",
    SCORES: "scores",
    HITCHART: "hitchart",
    MINISCOREBOARD: "miniscoreboard",
    SCORING_PLAYS: "scores",
    INNING: "inning",
    ALL_INNINGS: "all_innings",
    PLAYER_CARD: "playercard",
    HOT_COLD_ZONE: "hotcoldzone",
    DISPLAY_CONFIG: "displayconfig",
    JINGLES: "jingles",
    TEMPLATES: "tpl_lib",
    GAMECENTER: "gamecenter",
    TEAMVSPITCHER5Y: "teamVsPitcher5Y",
    TEAMLINEUPHITTINGSTATS: "teamLineupHittingStats",
    TICKETS: "ticketLinks",
    VIDEO: "video",
    LIVE_LOOKIN: "liveLookin",
    GD_CONFIG: "gdConfig",
    SKIN_CONFIG: "skin_config",
    TIMECODE: "timecode",
    STATIC_RESOURCES: "staticresources",
    MID_INNING_GAMES: "midInningGames",
    MOUNDBALL: "moundball",
    WRAPUPARTICLELIST: "wrapupArticleList",
    WRAPUPVIDEOLIST: "wrapupVideoList",
    STATCAST_BATTER_AVERAGES: "statcastBatterAverages",
    CONDENSEDGAME: "condensedGame",
});

